// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bgu_a bht_vf bht_a bht_q bht_k","AdSlotMail__mail--notLoaded":"bgu_b bht_eu bht_bj bht_vu","show-ad-not-loaded":"bgu_c","AdSlotMail__cta":"bgu_e"};